import { connect } from 'react-redux';
import { Image } from 'components/core/Image';

const SIZE_DIMENSIONS = {
	small: { width: '320', height: '180' },
	medium: { width: '480', height: '270' },
	large: { width: '640', height: '360' },
	xlarge: { width: '800', height: '450' },
};

export const enhance = connect(({ app }, { src, size }) => {
	const resolvedSize = size || 'small';
	const dimensions = SIZE_DIMENSIONS[resolvedSize] || SIZE_DIMENSIONS.small;

	return {
		src: `${app.cloudfrontUrl}/${resolvedSize}-compress/${src || 'default-sparefoot-photo.jpg'}`,
		className: 'facility-image',
		width: dimensions.width,
		height: dimensions.height,
	};
});

export default enhance(Image);
